import { render, staticRenderFns } from "./SideFixedBar.vue?vue&type=template&id=13044246&scoped=true"
import script from "./SideFixedBar.vue?vue&type=script&lang=js"
export * from "./SideFixedBar.vue?vue&type=script&lang=js"
import style0 from "./SideFixedBar.vue?vue&type=style&index=0&id=13044246&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13044246",
  null
  
)

export default component.exports